/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ErrorCode {
  QUOTA_EXCEPTION = 'quota_exception',
  SKILL_NOT_SUPPORTED = 'skill_not_supported',
  FEATURE_NOT_SUPPORTED = 'feature_not_supported',
  VALIDATION_ERROR = 'validation_error',
  VIDEO_QUOTA_EXCEPTION = 'video_quota_exception',
  DEEP_RESEARCH_QUOTA_EXCEPTION = 'deep_research_quota_exception',
}
